import { Link } from 'react-router-dom'

import Button from '../components/form/Button'
import { useI18N } from '../../libraries/i18n/hook'

const UpgradePro = () => {
  const { t } = useI18N()

  const handleUpgradeClick = () => {
    window.open('https://www.bloombyzrive.com/bloompro#bloompro-pricing', '_blank', 'noopener,noreferrer')
  }

  return (
    <div className='flex flex-col justify-center items-center gap-4 px-4 py-4 max-w-4xl mx-auto'>
      <div className='text-center'>
        <h1 className='text-3xl sm:text-5xl font-bold text-deep-green mb-3'>
          {t('upgradePro.title')}
        </h1>
        <p className='text-lg text-gray-600 mb-4'>
          {t('upgradePro.subtitle')}
        </p>
      </div>

      <div className='w-full max-w-2xl space-y-6'>
        <div className='bg-white rounded-lg p-6 shadow-sm border border-gray-100'>
          <h2 className='text-2xl font-semibold text-deep-green mb-4'>
            {t('upgradePro.benefitsHeader')}
          </h2>
          
          <div className='space-y-4'>
            <div className='flex items-start gap-3'>
              <div className='w-6 h-6 rounded-full bg-electric-green flex items-center justify-center flex-shrink-0 mt-0.5'>
                <span className='text-white text-sm font-bold'>1</span>
              </div>
              <p className='text-gray-700 leading-relaxed'>
                {t('upgradePro.benefit1')}
              </p>
            </div>
            
            <div className='flex items-start gap-3'>
              <div className='w-6 h-6 rounded-full bg-electric-green flex items-center justify-center flex-shrink-0 mt-0.5'>
                <span className='text-white text-sm font-bold'>2</span>
              </div>
              <p className='text-gray-700 leading-relaxed'>
                {t('upgradePro.benefit2')}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='flex flex-col sm:flex-row gap-4 items-center justify-center mt-8'>
        <Button 
          variant='primary' 
          size='md'
          onClick={handleUpgradeClick}
          className='min-w-48'
        >
          {t('upgradePro.cta')}
        </Button>
        
        <Button variant='tertiary' size='md'>
          <Link to='/'>
            {t('common.go.home')}
          </Link>
        </Button>
      </div>
    </div>
  )
}

export default UpgradePro
